const AbdulQadir = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="max-w-[70rem] mx-auto sm:px-[10rem] lg:flex md:grid md:justify-center lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] sm:text-[30px] font-bold">
              Abdul Qadir Aziz
            </h1>
            <p>CEO Intiana Private Limited</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/abdul-qadir-aziz4.jpg"
              alt=""
              className="xl:h-[26rem] lg:h-[26rem] md:h-[20rem] sm:h-[20rem] h-[17rem] leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="sm:text-[30px] text-[26px] font-bold">
              Abdul Qadir Aziz
            </h1>
            <p>CEO Intiana Private Limited</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-justify gap-4">
        <p>
          A seasoned aviation leader with over 30 years of international
          experience, Abdul Qadir Aziz has held senior management roles across
          various global airline operations. His expertise spans strategic
          airline management, operational excellence, and the development of
          high-performing teams. Renowned for his contributions to the airline
          industry's growth and efficiency, he has a proven track record of
          leading successful operational initiatives while maintaining high
          standards of safety and customer satisfaction. Abdul Qadir Aziz
          continues to shape the future of aviation by mentoring the next
          generation of leaders and driving innovation in airline operations.
        </p>
      </div>
    </div>
  );
};

export default AbdulQadir;
